const enum SLICES {
  AGENT = 'agent',
  AGENT_POSITION = 'agentPosition',
  AUTH = 'auth',
  AVAILABILITY = 'availability',
  CONTRACT = 'contract',
  RESOURCES = 'resources',
  SCHEDULE = 'schedule',
  USER = 'user',
  UTILS = 'utils',
}

export { SLICES };
